// Path: ./src/app/pages/ElasticTrigger/engagement/format.ts
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export const EMPTY = "—";

/** Absolute local timestamp, e.g. "Aug 15, 2026, 6:00 AM". */
export const formatTimestamp = (value?: string | Date | null): string => {
  if (!value) return EMPTY;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("MMM D, YYYY, h:mm A") : EMPTY;
};

/** "6 hours ago" / "in 2 hours", for spotting a stale or unscheduled job. */
export const formatRelative = (value?: string | Date | null): string => {
  if (!value) return EMPTY;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.fromNow() : EMPTY;
};

export const formatCount = (value?: number | null): string =>
  typeof value === "number" && Number.isFinite(value)
    ? value.toLocaleString()
    : EMPTY;

/**
 * Window label: "Aug 15, 12:00 AM → now" (a null `windowEnd` means the pull ran
 * up to the moment it executed).
 */
export const formatWindowRange = (start: string, end?: string): string => {
  const from = dayjs(start);
  const fromLabel = from.isValid() ? from.format("MMM D, h:mm A") : EMPTY;
  if (!end) return `${fromLabel} → now`;
  const to = dayjs(end);
  return `${fromLabel} → ${to.isValid() ? to.format("MMM D, h:mm A") : EMPTY}`;
};

/**
 * Share of fetched rows whose `item_id` resolved to a real flyer item.
 * `null` when the window matched nothing at all, so the caller can render "—"
 * rather than a misleading 0%.
 */
export const matchRate = (
  matchedRows: number,
  unmatchedRows: number,
): number | null => {
  const total = matchedRows + unmatchedRows;
  if (!total) return null;
  return Math.round((matchedRows / total) * 100);
};
